<script>
import { sync } from 'vuex-pathify'

export default {
	props: {
		useSearchDialog: Boolean,
		iconColor: String,
		iconOptions: Object,
		iconSize: [String, Number],
	},
	computed: {
		searchDialog: sync('shop/searchDialog'),
		cIconOptions() {
			return this.iconOptions?.iconType ? this.iconOptions : { iconType: 'default', icon: 'mdi-magnify' }
		},
	},
}
</script>

<template>
	<Button v-if="useSearchDialog" @click="searchDialog = true">
		<CustomIcon v-bind="cIconOptions" :icon-attrs="{ size: iconSize, color: iconColor }" />
	</Button>
	<AutocompleteSearchField v-else class="fixed-height searchfield" />
</template>

<style scoped lang="scss">
.fixed-height {
	height: 40px;
	vertical-align: middle;
}
</style>

